import { Box, MenuItem } from '@mui/material';

import ChevronDownIcon from '../../../../../components/svgs/ChevronDownIcon';
import {
  TP_OPTIONS_ROW_CHEVRON_HIDDEN_SX,
  TP_OPTIONS_ROW_CHEVRON_SX,
  TP_OPTIONS_ROW_SX,
} from '../styles';

import type { KeyboardEvent, MouseEvent } from 'react';
import type { TpOptionsMenuRowProps } from './types';

export default function TpOptionsMenuRow({
  entry,
  isSubmenuOpen,
  onOpenSubmenu,
  onCloseSubmenu,
  onAction,
  onKeyDown,
}: TpOptionsMenuRowProps) {
  const handleMouseEnter = (event: MouseEvent<HTMLLIElement>) => {
    if (entry.submenuId && !entry.disabled) {
      onOpenSubmenu(entry.submenuId, event.currentTarget, false);
      return;
    }
    onCloseSubmenu();
  };

  const handleClick = (event: MouseEvent<HTMLLIElement>) => {
    if (!entry.submenuId) {
      onAction(entry.id);
      return;
    }
    if (isSubmenuOpen) {
      onCloseSubmenu();
      return;
    }
    // A click with no pointer detail comes from the keyboard, so the submenu takes focus.
    onOpenSubmenu(entry.submenuId, event.currentTarget, event.detail === 0);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLLIElement>) => onKeyDown(event, entry);

  return (
    <MenuItem
      disableGutters
      disabled={entry.disabled}
      data-testid={entry.testId}
      aria-haspopup={entry.hasSubmenu ? 'menu' : undefined}
      aria-expanded={entry.hasSubmenu ? isSubmenuOpen : undefined}
      onMouseEnter={handleMouseEnter}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      sx={TP_OPTIONS_ROW_SX}
    >
      <Box
        aria-hidden
        sx={entry.hasSubmenu ? TP_OPTIONS_ROW_CHEVRON_SX : TP_OPTIONS_ROW_CHEVRON_HIDDEN_SX}
      >
        <ChevronDownIcon color="currentColor" />
      </Box>
      {entry.label}
    </MenuItem>
  );
}
